import ProfilePage from './ProfilePage.vue';

const routes = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      title: 'Profile',
      headerColor: '#ffffff',
      requiresAuth: true
    }
  }
];

export default routes;
